import {Component, OnInit} from '@angular/core';
import {API_URLS} from '../../../environments/env-routes';
import {APIHelper} from '../../../shared/services/api-helper/api-helper.service';

@Component({
  selector: 'information-section',
  templateUrl: './information-section.component.html',
  styleUrls: ['./information-section.component.scss']
})
export class InformationSectionComponent implements OnInit {
  public demodoughnutChartData: number[] = [0, 0, 0];
  public doughnutChartLabels: string[] = [
    'Image',
    'Text',
    'Ms-word',
    'Ms-powerpoint',
    'Ms-excel',
    'PDF',
    'Media',
    'autre'
  ];
  public options = {
    legend: {position: 'top'},
  };
  public piechartcolor = [
    {
      backgroundColor: [
        'rgba(110, 114, 20, 1)',
        'rgba(118, 183, 172, 1)',
        'rgba(0, 148, 97, 1)',
        'rgba(129, 78, 40, 1)',
        'rgba(129, 199, 111, 1)',
        'rgba(78, 232, 132, 1)',
        'rgba(61, 250, 234, 1)',
        'rgba(234, 250, 61, 1)',
        'rgba(33, 115, 1, 1)'
      ]
    }
  ];
  public doughnutChartType = 'pie';
  public filecount = 0;
  public totalzise = 0;
  public imagecount = 0;
  public mswordcount = 0;
  public mspowerpointcount = 0;
  public pdfcount = 0;
  public textcount = 0;
  public mediacount = 0;
  public autrecount = 0;
  public excelcount = 0;
  public allnodes: any[];

  constructor(private api: APIHelper) {
  }

  ngOnInit(): void {
    // this.getallnodes().then(res => {
    //   this.allnodes = res.items;
    //   this.filecount = res.metadata.itemCounts.documents;

    //   for (let i = 0; i < this.allnodes.length; i++) {
    //     const node = this.allnodes[i];

    //     this.totalzise += parseInt(node.size);
    //     if (node.mimetype.includes('image')) {
    //       this.imagecount += 1;
    //     } else if (node.mimetype.includes('msword')) {
    //       this.mswordcount += 1;
    //     } else if (node.mimetype.includes('ms-powerpoint')) {
    //       this.mspowerpointcount += 1;
    //     } else if (node.mimetype.includes('ms-excel')) {
    //       this.excelcount += 1;
    //     } else if (node.mimetype.includes('pdf')) {
    //       this.pdfcount += 1;
    //     } else if (node.mimetype.includes('text')) {
    //       this.textcount += 1;
    //     } else if (node.mimetype.includes('video')) {
    //       this.mediacount += 1;
    //     } else {
    //       this.autrecount += 1;
    //     }
    //   }

    //   this.demodoughnutChartData = [
    //     this.imagecount,
    //     this.textcount,
    //     this.mswordcount,
    //     this.mspowerpointcount,
    //     this.excelcount,
    //     this.pdfcount,
    //     this.mediacount,
    //     this.autrecount
    //   ];
    // });
  }

  public chartHovered(e: any): void {
  }

  public getallnodes() {
    const args = 'filter=all';
    return this.api.requestApi({
      action: API_URLS.stats.getAllnodes,
      queryArgs: args
    });
  }
}
